/*
 * Copyright 1999-2025 Jagex Ltd.
 */
import * as Routes from './routes';

export { Routes };
